import { PhoneCallIcon } from '@selina-finance/ui';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';

const classes = {
    container:
        'text-sm flex w-full items-start gap-3 rounded-lg border border-midnight-500 bg-white p-4 shadow-[0_3px_0_0_#090B2A] lg:border-0 lg:shadow-none',
    text: 'text-midnight-600',
};

type HelpProps = {
    className?: string;
};

export const Help = ({ className }: HelpProps) => {
    const { t } = useTranslation();

    return (
        <div className={clsx(classes.container, className)}>
            <div className='shrink-0'>
                <PhoneCallIcon />
            </div>
            <div className='flex flex-col'>
                <p className={clsx(classes.text, 'font-bold')}>
                    {t('help.title')}
                </p>
                <p className={classes.text}>{t('help.phone')}</p>
            </div>
        </div>
    );
};
